// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__KYDch","profile-wrapper":"Profile_profile-wrapper__noEEx","profile-thumbnail":"Profile_profile-thumbnail__9BciK","name":"Profile_name__gVZ6f"};